import { Box } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import { AnalysisType } from 'features/analysis/types'
import { FormattedMessage } from 'react-intl'
import { ReactElement } from 'react'
import { Catalog } from './catalog'

function AnalysisHeader({ analysisType, children }: { analysisType: AnalysisType; children?: ReactElement }) {
  const analysis = Catalog.find((analysis) => analysis.id === analysisType)
  return (
    <Box display="flex" flexDirection={'column'} mb={1}>
      <Box mb={0.5}>
        <Typography variant="subtitle2">{analysis?.label}</Typography>
      </Box>
      <Box>
        {children ? (
          children
        ) : (
          <Typography variant="body2" color="textSecondary">
            <FormattedMessage id={`analysis.${analysisType}.title`} />
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default AnalysisHeader
